/**
 * GTD Domain - Published Language Contracts
 * 
 * This module exports the Published Language that GTD Domain
 * exposes to downstream bounded contexts. Following Eric Evans
 * Strategic DDD principles for proper context integration.
 * 
 * These contracts represent the stable API that GTD Domain
 * commits to maintaining for its customers/suppliers.
 */

// Export everything from zodios-api (includes schemas and types)
export * from './zodios-api';

// Re-export project contracts that aren't in zodios-api
export * from './ProjectContracts';

// Export GTD semantic navigation capabilities
export * from '../../navigation';

/**
 * Version of the Published Language API
 * Increment when making breaking changes to contracts
 */
export const GTD_PUBLISHED_LANGUAGE_VERSION = '2.1.0';